import { usePopup, usePopupState } from '@contexts/popupContext';
import styles from '@styles/components/PopupDisplayer.module.css';
import { createPortal } from 'react-dom';

const PopupDisplayer = () => {
  const { hidePopup } = usePopup();
  const { PopupComponent, popupKey, listensToClickAway } = usePopupState();
  
  if (!PopupComponent) {
    return null;
  }

  return createPortal(
    <div className={styles['popup-overlay']} onClick={listensToClickAway ? hidePopup : () => {}}>
      <div className={styles['popup-content']} onClick={e => e.stopPropagation()}>
        <PopupComponent key={popupKey} />
      </div>
    </div>,
    document.body
  );
};

export default PopupDisplayer;